export default {
  en: {
    ACCOUNT_CODE: 'Account Code (LAC)',
    ACCOUNT_CODE_TT: 'Your Jornaya Account Code',
    AUDIT_KEY: 'Audit Key (LAK)',
    AUDIT_KEY_TT: 'The Audit Key for this query.',
    AGENCY_CODE: 'Agency Code',
    AGENCY_CODE_TT: 'This parameter allows a company that is an AOR or LMS for a client to perform queries on behalf of that client and identify itself accordingly by passing in its own Account Code.'
  }
};